module.exports = __webpack_public_path__ + "img/ActivEngage.d03e04b2.png";